
















import Vue from "vue";
export default Vue.extend({
  name: "Touch",
  methods: {
    doSomething() {
      console.log("doSomething");
      console.log(event);
    },
    rotateAThing() {
      console.log("rotateAThing");
      console.log(event);
    },
    tapAThing() {
      console.log("tapAThing");
      console.log(event);
    },
  },
});
